import { render, staticRenderFns } from "./paModal.vue?vue&type=template&id=23447c70"
import script from "./paModal.vue?vue&type=script&lang=js"
export * from "./paModal.vue?vue&type=script&lang=js"
import style0 from "./paModal.vue?vue&type=style&index=0&id=23447c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports